<div>
    <pdf-viewer [src]="pdfSrc"
                [render-text]="true"
                [fit-to-page]="true"
                style="width:100%; height: 100vh; background-color: lightgray;"></pdf-viewer>
</div>